import cosmos from "@lunie/cosmos-ledger";
import ethereum from "@ledgerhq/hw-app-eth";
import iov from "./iov";
import terra from "./terra";

export default {
  cosmos,
  ethereum,
  iov,
  terra,
};
